<template>
  <hic-dialog v-if="result" append-to-body :close-on-click-modal="false" @close="$emit('update:visible', false)" title="任务结果" :visible="visible" width="60rem" top="10vh">
    <template v-if="result.success < result.total">
      <h2 class="center danger">
        <i class="el-icon-warning right-pad" style="font-size: 1.5rem" />{{ result.action }}记录共 <span class="info">{{ result.total }}</span> 条，失败 <span class="info">{{ result.total - result.success }}</span> 条
      </h2>
      <el-table :data="result.errItems" height="30rem">
        <el-table-column property="no" label="医嘱号" align="left" width="130" sortable>
          <template slot-scope="{ row }">
            <el-link v-if="row.type == '药品'" type="danger" @click="queryAlternative(row)">{{ row.no }}</el-link>
            <span v-else class="danger">{{ row.no }}</span>
          </template>
        </el-table-column>
        <el-table-column property="bedNo" label="床位号" align="left" width="100" sortable></el-table-column>
        <el-table-column property="patientName" label="患者" align="left" width="150" sortable></el-table-column>
        <el-table-column property="name" label="内容" align="left" sortable></el-table-column>
        <el-table-column property="memo" label="失败原因" min-width="200">
          <template slot-scope="{ row }">
            <span class="warning">{{ row.memo }}</span>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <h2 v-else class="center success">
      <i class="el-icon-success right-pad" style="font-size: 1.5rem" />{{ result.action }}记录共 <span class="info">{{ result.total }}</span> 条，全部成功！
    </h2>
    <template slot="footer">
      <el-button type="info" @click.native="$emit('update:visible', false)">关 闭</el-button>
    </template>
  </hic-dialog>
</template>

<script>
  import api from "./api.js";
  export default {
    props: {
      visible: Boolean,
      result: Object,
    },
    data() {
      return {
        options: {
          drug: [{ code: "", name: "请选择" }],
        },
      };
    },
    methods: {
      queryAlternative({ code, storehouseCode }) {
        api.Drug.getDrugs({
          pageSize: 10,
          keyword: code,
          storehouseCode,
          sort: "sortNum",
        }).then((res) => {
          this.options.drug = res.items;
        });
      },
    },
  };
</script>
